export var ArticleVersionNumber;
(function (ArticleVersionNumber) {
    ArticleVersionNumber[ArticleVersionNumber["VERSION_A"] = -1] = "VERSION_A";
    ArticleVersionNumber[ArticleVersionNumber["VERSION_B"] = 0] = "VERSION_B";
})(ArticleVersionNumber || (ArticleVersionNumber = {}));
//# sourceMappingURL=article-version.enum.js.map